<template>
  <div class="newsletter-form-wrap">
    <div v-if="subscribed" class="newsletter-success" role="status" data-testid="newsletter-success">
      <h3>Check your inbox, {{ firstName }}.</h3>
      <p>
        I sent a confirmation to {{ emailAddress }}. Click the link in that email to confirm your
        subscription.
      </p>
    </div>
    <form v-else class="newsletter-form" @submit.prevent="submit">
      <div class="newsletter-fields">
        <div>
          <label :for="`${formId}-name`">First name</label>
          <input
            :id="`${formId}-name`"
            v-model="firstName"
            name="firstName"
            data-testid="newsletter-first-name"
            autocomplete="given-name"
            placeholder="Your first name"
            required
            :disabled="pending || !isMounted"
          />
        </div>
        <div>
          <label :for="`${formId}-email`">Email address</label>
          <input
            :id="`${formId}-email`"
            v-model="emailAddress"
            name="email"
            data-testid="newsletter-email"
            type="email"
            autocomplete="email"
            placeholder="you@example.com"
            required
            :disabled="pending || !isMounted"
          />
        </div>
      </div>
      <button
        type="submit"
        class="editorial-pill"
        :disabled="pending || !isMounted"
        data-testid="subscribe-button"
      >
        {{ pending ? 'Sending…' : 'Subscribe' }}
        <span aria-hidden="true">↗</span>
      </button>
      <p v-if="error" role="alert" class="newsletter-error" data-testid="newsletter-error">{{ error }}</p>
      <p class="newsletter-privacy">
        You can unsubscribe any time.
        <br />
        <NuxtLink to="/privacy-policy">Here's how I handle your data.</NuxtLink>
      </p>
    </form>
  </div>
</template>
<script setup lang="ts">
const isMounted = useMounted()
const formId = useId()
const firstName = ref('')
const emailAddress = ref('')
const pending = ref(false)
const subscribed = ref(false)
const error = ref('')
async function submit() {
  if (pending.value) return
  if (!firstName.value.trim() || !emailAddress.value.trim()) {
    error.value = 'Please enter your name and email address.'
    return
  }
  pending.value = true
  error.value = ''
  try {
    const data = await $fetch<{ subscription?: unknown }>('/api/subscribe', {
      method: 'POST',
      body: { email: emailAddress.value.trim(), firstName: firstName.value.trim() }
    })
    if (!data.subscription) throw new Error('Subscription failed')
    subscribed.value = true
  } catch {
    error.value = "That didn't go through. Please try again, or email me at filip@filiphric.com."
  } finally {
    pending.value = false
  }
}
</script>
